import React, {Component} from 'react';
//import io from 'socket.io-client';
import Loading from "../Common/Loading";
import Navbar from "../Common/Navbar";
import Actionbar from "../Common/Actionbar";
import {
    BsCarFront,
    FaAngleLeft, FaCheckCircle, FaCircle,
    GiMechanicGarage,
    MdChildCare,
    RiAlarmWarningFill,
    SiCoronaengine,
    TbBatteryEco, TbHelpHexagon,
    TbNetwork
} from "react-icons/all";

import {toast} from "react-toastify";
import API from "../../services/API";
import Toast from "../Common/Toast";


String.prototype.hashCode = function() {
    let hash = 0,
        i, chr;
    if (this.length === 0) return hash;
    for (i = 0; i < this.length; i++) {
        chr = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

class AdvancedConfigs extends Component {
    state = {
        cars: [],
        isLoaded: false,
        'r1' : '0',
        'r2' : '0',
        'r3' : '0',
        'r4' : '0',
        'r5' : '0',
        'r6' : '0',
        'r7' : '0',
        'r8' : '0',
        activeCar: window.localStorage.getItem("_ac" ),

    }

    sendToSocket = (command) => {
        const ConnectionType = window.localStorage.getItem("connection_type");
        if(ConnectionType === 'internet') {
            const request = {
                'mobile': this.state.cars[this.state.activeCar].main_phone,
                'device': this.state.cars[this.state.activeCar].car_code,
                'password': window.localStorage.getItem("password"),
                'command': command
            };
            this.setState({isLoaded: false})
            API.socketSendData(request)
                .then((response) => {
                    toast.success('دستور با موفقیت به دستگاه ارسال شد')
                    this.setState({isLoaded: true})
                })
        }
        else {
            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            if(!check) {
                toast.error('شما در حال استفاده در کامپیوتر هستید، امکان ارسال پیامک با استفاده از کامپیوتر وجود ندارد. لطفا نحوه ارتباط را به حالت اینترنتی تغییر دهید ');
                return false;
            }
            let body = '*' + command + '#';

            if (navigator.userAgent.match(/Android/i)) {
                window.open(`sms://${this.state.cars[this.state.activeCar].phone_device}/?body=${body}`);

            }
            if (navigator.userAgent.match(/iPhone/i)) {
                window.open(`sms://${this.state.cars[this.state.activeCar].phone_device}/&body=${body}`);
            }
        }

    }

    render() {
        const carType = this.state.isLoaded  ? this.state.cars[this.state.activeCar].car_code.charAt(0).toUpperCase() : '';
        return (
            <React.Fragment>

                {
                    !this.state.isLoaded && <Loading />
                }
<Actionbar title='  تنظیمات پیشرفته' noBack={1}/>
                <Toast/>


                <nav className="container-fluid profile-list-items mt-5">
                    <div className="row">
                        <div className="col-12 pt-2 ">
                            <select id="car-list-select" className='my-3'
                                    value={this.state.activeCar}
                                    onChange={
                                        (val) => {
                                            this.setState({'activeCar': parseInt(val.target.value)})
                                        }
                                    }
                            >
                                {
                                    this.state.cars.map((car, index) => {

                                        return (
                                            <option className="row transaction-item" key={car.car_code}
                                                    value={index}>
                                                {car.car_name}
                                                &nbsp;
                                                (

                                                {car.car_code}

                                                )

                                            </option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>


                    {

                        (carType === 'S' || carType === 'F' || carType === 'R' ) &&
                        <div className="row mt-4 rtl px-4 menu-list-item"

                        >

                            <div className="col-1">
                                <MdChildCare className="text-white list-icon"/>
                            </div>
                            <div className="col-9 menu-text "
                                 onClick={
                                     () => {
                                         const command = parseInt(this.state.r6) ? `rez50` :`rez51`;
                                         this.sendToSocket(command);
                                         this.setState({
                                             'r6' : 1 - this.state.r6
                                         })
                                     }
                                 }
                            >
                                {
                                    parseInt(this.state.r6) ? 'غیر' : ''
                                }
                                &nbsp;
                                فعال کردن
                                قفل کودک
                            </div>
                            <div className="col-1"
                                 onClick={() => {toast(
                                     '     درب خودرو با گذر از سرعت 20km به صورت هوشمند قفل می شود\n'
                                 )}}
                            >
                                <TbHelpHexagon className="text-warning" />
                            </div>
                            <div className="col-1">
                                {
                                    parseInt(this.state.r6) ?
                                        <FaCheckCircle className='text-success' />
                                        :
                                        <FaCircle className='text-danger' />
                                }

                            </div>

                        </div>
                    }

                    {

                        ( carType === 'R' ) &&
                    <div className="row mt-4 rtl px-4 menu-list-item"

                    >

                        <div className="col-1">
                            <SiCoronaengine className="text-white list-icon"/>
                        </div>
                        <div className="col-9 menu-text "
                             onClick={
                                 () => {

                                     const command = parseInt(this.state.r4) ? `rez30` :`rez31`;
                                     this.sendToSocket(command);
                                     this.setState({
                                         'r4' : 1 - this.state.r4
                                     })
                                 }
                             }
                        >
                            {
                                parseInt(this.state.r4) ? 'غیر' : ''
                            }
                            &nbsp;
                            فعال کردن
                           رزرو استارت
                        </div>
                        <div className="col-1"
                             onClick={() => {toast(
                                 '      در فصل زمستان فعال شود جهت روشن کردن خودرو و گرم کردن آن از راه دور\n'
                             )}}
                        >
                            <TbHelpHexagon className="text-warning" />
                        </div>
                        <div className="col-1">
                            {
                                parseInt(this.state.r4) ?
                                    <FaCheckCircle className='text-success' />
                                    :
                                    <FaCircle className='text-danger' />
                            }
                        </div>

                    </div>
                    }

                    {

                        ( carType === 'F' || carType === 'R' ) &&
                    <div className="row mt-4 rtl px-4 menu-list-item"

                    >

                        <div className="col-1">
                            <GiMechanicGarage className="text-white list-icon"/>
                        </div>
                        <div className="col-9 menu-text "
                             onClick={
                                 () => {

                                     const command = parseInt(this.state.r4) ? `rez40` :`rez41`;
                                     this.sendToSocket(command);
                                     this.setState({
                                         'r5' : 1 - this.state.r5
                                     })
                                 }
                             }
                        >
                            {
                                parseInt(this.state.r5) ? 'غیر' : ''
                            }
                            &nbsp;
                            فعال کردن
                          حالت تعمیرگاه
                        </div>
                        <div className="col-1"
                             onClick={() => {toast(
                                 '        دزدگیر تا رسیدن به تعمیرگاه غیر فعال می شود\n'
                             )}}
                        >
                            <TbHelpHexagon className="text-warning" />
                        </div>
                        <div className="col-1">
                            {
                                parseInt(this.state.r5) ?
                                    <FaCheckCircle className='text-success' />
                                    :
                                    <FaCircle className='text-danger' />
                            }
                        </div>

                    </div>
                    }

                    {

                        (carType === 'K' || carType === 'M' ) &&
                    <div className="row mt-4 rtl px-4 menu-list-item"

                    >

                        <div className="col-1">
                            <TbBatteryEco className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text "
                             onClick={
                                 () => {

                                     const command = parseInt(this.state.r4) ? `rez00` :`rez01`;
                                     this.sendToSocket(command);
                                     this.setState({
                                         'r1' : 1 - this.state.r1
                                     })
                                 }
                             }
                        >
                            {
                                parseInt(this.state.r1) ? 'غیر' : ''
                            }
                            &nbsp;
                            فعال کردن
                         مصرف بهینه باتری
                        </div>

                        <div className="col-1">
                            {
                                parseInt(this.state.r1) ?
                                    <FaCheckCircle className='text-success' />
                                    :
                                    <FaCircle className='text-danger' />
                            }
                        </div>

                    </div>
                    }

                    {

                        (carType === 'S' || carType === 'K' || carType === 'F' || carType === 'R' ) &&
                    <div className="row mt-4 rtl px-4 menu-list-item"

                    >

                        <div className="col-1">
                            <TbNetwork className="text-white list-icon"/>
                        </div>
                        <div className="col-9 menu-text "
                             onClick={
                                 () => {
                                     const command = parseInt(this.state.r4) ? `rez10` :`rez11`;
                                     this.sendToSocket(command);
                                     this.setState({
                                         'r2' : 1 - this.state.r2
                                     })
                                 }
                             }
                        >
                            {
                                parseInt(this.state.r2) ? 'غیر' : ''
                            }
                            &nbsp;
                            فعال کردن
                        اجازه روشن شدن خارج از شبکه
                        </div>
                        <div className="col-1"
                             onClick={() => {toast(
                                 '        در صورتی که دستور قطع رله ارسال شده باشد و بعد از آن سیمکارت ردیاب از شبکه خارج شود رله به حالت وصل قرار می گیرد\n'
                             )}}
                        >
                            <TbHelpHexagon className="text-warning" />
                        </div>
                        <div className="col-1">
                            {
                                parseInt(this.state.r2) ?
                                    <FaCheckCircle className='text-success' />
                                    :
                                    <FaCircle className='text-danger' />
                            }
                        </div>

                    </div>
                    }

                    {

                        (carType === 'S' || carType === 'K' || carType === 'F' || carType === 'R' ) &&
                    <div className="row mt-4 rtl px-4 menu-list-item"

                    >

                        <div className="col-1">
                            <BsCarFront className="text-white list-icon"/>
                        </div>
                        <div className="col-9 menu-text "
                             onClick={
                                 () => {
                                     const command = parseInt(this.state.r4) ? `rez20` :`rez21`;
                                     this.sendToSocket(command);
                                     this.setState({
                                         'r3' : 1 - this.state.r3
                                     })

                                 }
                             }
                        >
                            {
                                parseInt(this.state.r3) ? 'غیر' : ''
                            }
                            &nbsp;
                            فعال کردن

                        گزارش ورود و خروج به خودرو
                        </div>
                        <div className="col-1"
                             onClick={() => {toast(
                      '        با هر بار باز شدن درب خودرو به کاربر پیامک داده می شود\n'
                             )}}
                        >
                            <TbHelpHexagon className="text-warning" />
                        </div>
                        <div className="col-1">
                            {
                                parseInt(this.state.r3) ?
                                    <FaCheckCircle className='text-success' />
                                    :
                                    <FaCircle className='text-danger' />
                            }
                        </div>

                    </div>
                    }

                    {

                        (carType === 'S' || carType === 'K' ) &&
                    <div className="row mt-4 rtl px-4 menu-list-item"
                             onClick={
                                 () => {
                                     const command = `rez61`;
                                     this.sendToSocket(command);

                                 }
                             }
                    >

                        <div className="col-1">
                            <RiAlarmWarningFill className="text-white list-icon"/>
                        </div>
                        <div className="col-10 menu-text ">
                        فعال شدن حالت دزدگیر اتوماتیک
                        </div>
                        <div className="col-1">
                            <FaAngleLeft className="text-primary-color" />
                        </div>

                    </div>

                    }

                </nav>

                <Navbar />
            </React.Fragment>
        );
    }
    componentDidMount = () => {
        const mobile = window.localStorage.getItem("mobile");
        const password = window.localStorage.getItem("password");

        if (!mobile && !password) {
            window.location.replace('/')
        }
        API.getCarData(mobile, password)
            .then((response) => {

                this.setState({
                    isLoaded: true,
                    'cars': response.car_act,
                    'r1' : response.car_act[this.state.activeCar].rezerv1[0],
                    'r2' : response.car_act[this.state.activeCar].rezerv1[1],
                    'r3' : response.car_act[this.state.activeCar].rezerv1[2],
                    'r4' : response.car_act[this.state.activeCar].rezerv1[3],
                    'r5' : response.car_act[this.state.activeCar].rezerv1[4],
                    'r6' : response.car_act[this.state.activeCar].rezerv1[5],
                    'r7' : response.car_act[this.state.activeCar].rezerv1[6],
                    'r8' : response.car_act[this.state.activeCar].rezerv1[7],
                })
                setTimeout(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            })
    }
}

export default AdvancedConfigs;